import React from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

const RegisterConfirmation = () => {
  const { t } = useTranslation()
  const pageName = 'REGISTER_CONFIRMATION'

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle title={t(`${pageName}_TITLE`)} description="" />

      <div className="p-3">
        <p>{t(`${pageName}_DESCRIPTION`)}</p>

        <BottomImage name={pageName} />
      </div>

      <Footer />
    </div>
  )
}

export default RegisterConfirmation
